<template>
  <OrderAddressEdit
    :loading="loading"
    :order="orderData"
    field="shippingAddress"
    @reload="$emit('reload')"
  />
</template>

<script>

import OrderAddressEdit from "@/components/OrderOverview/OrderAddressEdit"

export default {
  props: {
    loading: Boolean,
    orderData: Object,
  },
  components: {
    OrderAddressEdit,
  },
}

</script>

